<template>
  <div class="flex-card">
    <Card translate="no"
      v-for="(item, index) in machinesData"
      class="cards"
      :key="index"
      :index="index"
      :item="item.name"
      :score="item.score"
      :photo="photo[`${item.id}`]"
      @modal-toggle="$emit('render-single-machine-page', index)"
    />
  </div>
</template>

<script>
/* eslint-disable */
import Card from './Card';
export default {
  name: 'Machines',
  components: {
    Card,
  },
  props: ['machinesData', 'photo'],
};

</script>

<style>

@media only screen and (min-width: 770px) {
  .flex-card {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    text-align: center;
    width: 100%;
  }

  .flex-card .cards {
    width: 50%;
  }
}

</style>
